import React, { FC } from 'react';

import { Icon } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import ActionButton, { ActionButtonVariants, IActionButtonProps } from 'components/action-button';
import { Box } from 'components/ui';
import { primitive } from 'styles/constants';

interface IRefreshButtonProps extends IActionButtonProps {
  onPress: (ev: any) => void;
}

const styles = StyleSheet.create({ container: { alignItems: 'center', marginVertical: 16 } });

export const RefreshButton: FC<React.PropsWithChildren<IRefreshButtonProps>> = ({
  children,
  onPress,
}) => {
  return (
    <Box style={styles.container}>
      <ActionButton
        variant={ActionButtonVariants.OUTLINE}
        onPress={onPress}
        startIcon={<Icon variant="refresh" color={primitive.$bbqBrown} aria-hidden />}
      >
        {children}
      </ActionButton>
    </Box>
  );
};
